import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setupWarehouseHeader: {
    description: 'Header for the warehouse setup section',
    defaultMessage: 'Link your shipping & inventory',
    id: 'e3OLXw',
  },
  linkToShipFrom: {
    description: 'Subheader for the ship from location page',
    defaultMessage: 'Link Ship Froms',
    id: '8Eyo9m',
  },
  sectionDescription: {
    description: 'Description for the warehouse setup section',
    defaultMessage: 'Link your Ship From Locations to where your stock is held.',
    id: 'aqAEqa',
  },
});
